/* Armazém 11/2026 — roleta "Gire e ganhe" (sections/roleta.liquid). Sorteio por peso com crypto; todo mundo ganha;
2ª rodada sobe 1 nível ou mantém (50/50), nunca até o prêmio maior (só no 1º giro); cupom em localStorage.roleta {code,label,tier,at}; 1 giro por aparelho
(ou por telefone, se a seção tiver `endpoint`: o servidor pode trocar o prêmio). Só textContent, nunca innerHTML. */
(function () {
if (customElements.get('roleta-giro')) return;
var LS = {
get: function (k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
set: function (k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
};
var rnd = function () { var a = new Uint32Array(1); crypto.getRandomValues(a); return a[0] / 4294967296; };
var pick = function (prizes) {
var total = prizes.reduce(function (s, p) { return s + (+p.weight || 0); }, 0), r = rnd() * total;
for (var i = 0; i < prizes.length; i++) { r -= +prizes[i].weight || 0; if (r < 0) return i; }
return prizes.length - 1;
};
var digits = function (s) { return (s || '').replace(/\D/g, ''); };
var fmtTel = function (d) {
d = d.slice(0, 11);
if (d.length <= 2) return d;
if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
};

class Roleta extends HTMLElement {
connectedCallback() {
try { this.prizes = JSON.parse(this.dataset.prizes || '[]'); } catch (e) { this.prizes = []; }
if (!this.prizes.length) return;
this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
this.steps = { form: this.querySelector('[data-step="form"]'), wheel: this.querySelector('[data-step="wheel"]'), coupon: this.querySelector('[data-step="coupon"]'), rules: this.querySelector('[data-step="rules"]') };
this.wheel = this.querySelector('[data-wheel]');
this.fab = document.querySelector('[data-fab]');
this.rot = 0; this.subiu = false; this.idx = -1; this.contato = {};
this.demo = this.dataset.demo === 'true'; this.querySelector('[data-demo-badge]').hidden = !this.demo;
this.querySelector('[data-girar]').addEventListener('click', () => this.girarDemo());
this.querySelector('[data-wrap]').addEventListener('click', () => { if (!this.querySelector('[data-girar]').hidden) this.girarDemo(); });
this.buildWheel();
this.addEventListener('click', (e) => { if (e.target.closest('[data-close]')) this.close(true); });
// "Regras da promoção" abre um painel dentro da própria roleta (pedido do Marcelo 04/11); Voltar devolve ao passo anterior
this.addEventListener('click', (e) => {
if (e.target.closest('[data-regras]')) { e.preventDefault(); this.stepAntes = Object.keys(this.steps).find((k) => this.steps[k] && !this.steps[k].hidden) || 'form'; this.show('rules'); }
if (e.target.closest('[data-regras-voltar]')) this.show(this.stepAntes || 'form');
});
this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(true); });
this.steps.form.addEventListener('submit', (e) => { e.preventDefault(); this.enviar(); });
var tel = this.steps.form.querySelector('[name="whatsapp"]');
if (tel) tel.addEventListener('input', () => { tel.value = fmtTel(digits(tel.value)); });
this.querySelector('[data-subir]').addEventListener('click', () => this.subir());
this.querySelector('[data-pegar]').addEventListener('click', () => this.mostrarCupom());
this.querySelector('[data-copy]').addEventListener('click', () => this.copiar());
if (this.fab) {
this.fab.addEventListener('click', (e) => { if (e.target.closest('[data-fab-x]')) { e.stopPropagation(); this.fab.hidden = true; LS.set('roleta_fab_off', Date.now()); return; } this.open(); });
}
this.boot();
}
boot() {
var fabOff = +LS.get('roleta_fab_off') || 0; this.fabOff = fabOff && Date.now() - fabOff < 86400000;
if (this.demo) { var pausa = false; try { pausa = sessionStorage.getItem('roleta_demo_pausa') === '1'; } catch (e) {} if (pausa) return this.showFab('🎁 Gire e ganhe'); return this.open(); }
var res = LS.get('roleta');
if (res && res.code) { if (this.expirado(res)) return; this.resultado = res; this.showFab('🎁 Seu cupom'); return; }
var fechou = +LS.get('roleta_fechou') || 0, fechouEm = +LS.get('roleta_fechou_em') || 0;
// fechou sem girar = não abre mais sozinha (só o botãozinho) por 7 dias; depois pode tentar de novo (opção A, 04/11)
if (fechou >= 1 && Date.now() - fechouEm < 7 * 86400000) return this.showFab('🎁 Gire e ganhe');
if (document.body.classList.contains('page-videos') || /\/checkouts?\b|\/cart\b/.test(location.pathname)) return;
// abre sozinha só nos modelos listados no tema (padrão home + coleções); nos outros (ex.: produto) fica só o botãozinho (04/11)
if (this.dataset.auto !== 'true') return this.showFab('🎁 Gire e ganhe');
var pages = 1;
try { pages = (+sessionStorage.getItem('roleta_pages') || 0) + 1; sessionStorage.setItem('roleta_pages', String(pages)); } catch (e) {}
if (pages < (+this.dataset.minPages || 2)) return;
setTimeout(() => { if (this.hidden) this.open(); }, (+this.dataset.delay || 20) * 1000);
}
expirado(res) { return Date.now() - res.at > (+this.dataset.validHours || 24) * 3600000; }
showFab(txt) {
if (!this.fab || this.fabOff) return;
this.fab.textContent = '';
var ico = document.createElement('span'); ico.className = 'roleta__fab-ico'; ico.textContent = '🎁'; this.fab.appendChild(ico);
var t = document.createElement('span'); t.className = 'roleta__fab-txt'; t.textContent = txt.replace(/^🎁\s*/, ''); this.fab.appendChild(t);
var x = document.createElement('span'); x.className = 'roleta__fab-x'; x.setAttribute('data-fab-x', ''); x.setAttribute('role', 'button'); x.setAttribute('aria-label', 'Esconder'); x.textContent = '×'; this.fab.appendChild(x);
this.fab.hidden = false;
}
buildWheel() {
// fatias: cada prêmio aparece 2× (roleta cheia, alternando cores); a CHANCE continua pelo peso, não pelo nº de fatias
var idx = this.prizes.map((p, i) => i);
this.slices = idx.length <= 5 ? idx.concat(idx) : idx;
var n = this.slices.length, seg = 360 / n, gap = 1.2, stops = [];
this.slices.forEach((pi, s) => {
var p = this.prizes[pi], a = s * seg, b = (s + 1) * seg;
stops.push('#fff ' + a + 'deg ' + (a + gap) + 'deg', p.color + ' ' + (a + gap) + 'deg ' + (b - gap) + 'deg', '#fff ' + (b - gap) + 'deg ' + b + 'deg');
var el = document.createElement('span');
el.className = 'roleta__label' + (p.label.length > 8 ? ' is-long' : ''); el.textContent = p.label;
el.style.transform = 'rotate(' + (a + seg / 2 - 90) + 'deg)';
this.wheel.appendChild(el);
});
this.wheel.style.background = 'conic-gradient(' + stops.join(',') + ')';
var rim = this.querySelector('[data-rim]');
for (var i = 0; i < 20; i++) { var l = document.createElement('i'); l.className = 'roleta__light'; l.style.transform = 'rotate(' + (i * 18) + 'deg) translateY(-50%)'; l.style.setProperty('--i', String(i)); rim.appendChild(l); }
}
confete() {
var box = this.querySelector('[data-confetti]'); if (!box || this.reduced) return;
box.textContent = '';
var cores = ['#ff7e01', '#ffb15e', '#222', '#207758', '#fff'];
for (var i = 0; i < 26; i++) {
var c = document.createElement('i');
c.style.left = (50 + (rnd() - 0.5) * 70) + '%';
c.style.background = cores[i % cores.length];
c.style.setProperty('--dx', ((rnd() - 0.5) * 160).toFixed(0) + 'px');
c.style.setProperty('--r', (rnd() * 720).toFixed(0) + 'deg');
c.style.animationDelay = (rnd() * 0.25).toFixed(2) + 's';
box.appendChild(c);
}
setTimeout(() => { box.textContent = ''; }, 1800);
}
open() {
this.hidden = false; document.body.classList.add('roleta-aberta');
if (this.resultado) { this.show('coupon'); this.renderCupom(); } else this.show(this.idx >= 0 || this.demo ? 'wheel' : 'form');
if (this.demo && this.idx < 0) this.querySelector('[data-girar]').hidden = false;
var f = this.querySelector('[data-step="form"]:not([hidden]) input') || this.querySelector('.roleta__close');
f.focus({ preventScroll: true });
}
close(porUsuario) {
this.hidden = true; document.body.classList.remove('roleta-aberta');
if (this.resultado) return this.showFab('🎁 Seu cupom');
if (this.demo) return this.showFab('🎁 Gire e ganhe');
if (porUsuario && this.idx < 0) { LS.set('roleta_fechou', (+LS.get('roleta_fechou') || 0) + 1); LS.set('roleta_fechou_em', Date.now()); }
this.showFab('🎁 Gire e ganhe');
}
show(step) { Object.keys(this.steps).forEach((k) => { if (this.steps[k]) this.steps[k].hidden = k !== step; }); }
erro(msg) { var el = this.steps.form.querySelector('[data-erro]'); el.textContent = msg; el.hidden = !msg; }
status(t) { this.querySelector('[data-status]').textContent = t; }
enviar() {
var f = this.steps.form, tel = f.querySelector('[name="whatsapp"]'), em = f.querySelector('[name="email"]'), d = tel ? digits(tel.value) : '';
if (tel && (d.length < 10 || d.length > 11)) return this.erro('Confere o WhatsApp com DDD (10 ou 11 números).');
if (em && (em.required || em.value.trim()) && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em.value.trim())) return this.erro('Confere o e-mail.');
this.erro('');
this.contato = { nome: ((f.querySelector('[name="nome"]') || {}).value || '').trim(), whatsapp: d, email: em ? em.value.trim() : '' };
f.querySelector('button[type="submit"]').disabled = true;
this.show('wheel'); this.status('Girando…');
this.registrar(pick(this.prizes), (idx) => this.girar(idx, () => this.parou(idx)));
}
registrar(i, cb) {
var url = this.dataset.endpoint, p = this.prizes[i];
if (!url) return cb(i);
var done = false, fim = (idx) => { if (!done) { done = true; cb(idx); } };
setTimeout(() => fim(i), 2500);
fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true,
body: JSON.stringify(Object.assign({}, this.contato, { premio: p.label, cupom: p.code, pagina: location.pathname, utm: location.search.slice(1),
// o servidor sorteia de novo com os mesmos pesos (e cria o cupom único do frete): manda a tabela de prêmios e a validade
premios: this.prizes.map((x) => ({ label: x.label, code: x.code, weight: +x.weight || 0, tier: +x.tier || 0 })), valid_hours: +this.dataset.validHours || 24 })) })
.then((r) => r.json())
.then((j) => {
// o servidor pode devolver cupom único do frete (ex.: GIROFRETE-7K3Q): a fatia é a do prêmio cujo código é o prefixo; o código único vai pro cupom
var k = -1; this.cupomServidor = null;
if (j && j.cupom) { var c = String(j.cupom).toUpperCase(); k = this.prizes.findIndex((x) => c === x.code || c.indexOf(x.code + '-') === 0); if (k >= 0 && c !== this.prizes[k].code) this.cupomServidor = c; }
fim(k >= 0 ? k : i);
})
.catch(() => fim(i));
}
girar(idx, cb) {
var cands = this.slices.map((pi, s) => s).filter((s) => this.slices[s] === idx);
var fatia = cands[Math.floor(rnd() * cands.length)], n = this.slices.length, seg = 360 / n;
var alvo = 360 - (fatia * seg + seg / 2) + (rnd() - 0.5) * seg * 0.5;
var atual = ((this.rot % 360) + 360) % 360, delta = (((alvo - atual) % 360) + 360) % 360;
this.rot += (this.reduced ? 360 : 1800) + delta;
var wrap = this.querySelector('[data-wrap]'); wrap.classList.add('is-spinning');
this.wheel.style.transition = 'transform ' + (this.reduced ? 0.6 : 4.2) + 's cubic-bezier(0.12, 0.7, 0.08, 1)';
this.wheel.style.transform = 'rotate(' + this.rot + 'deg)';
setTimeout(() => { wrap.classList.remove('is-spinning'); cb(); }, this.reduced ? 700 : 4400);
}
parou(idx) {
this.idx = idx; var p = this.prizes[idx];
this.confete();
this.status('Você ganhou ' + p.label + '!');
this.querySelector('[data-acoes]').hidden = false;
// Pedido do Marcelo 04/11: o prêmio maior (tier mais alto, frete/R$25) só sai no 1º giro; o 2º giro sobe no máximo até 10%.
var topo = Math.max.apply(null, this.prizes.map((x) => +x.tier || 0));
this.querySelector('[data-subir]').hidden = this.subiu || !this.prizes.some((x) => x.tier > p.tier && x.tier < topo);
}
subir() {
this.subiu = true; this.querySelector('[data-acoes]').hidden = true;
var p = this.prizes[this.idx], idx = this.idx, sobe = rnd() < 0.5;
if (sobe) {
var topo = Math.max.apply(null, this.prizes.map((x) => +x.tier || 0));
var cand = this.prizes.map((x, i) => i).filter((i) => this.prizes[i].tier > p.tier && this.prizes[i].tier < topo).sort((a, b) => this.prizes[a].tier - this.prizes[b].tier);
if (cand.length) idx = cand[0];
}
this.status('Girando de novo…');
this.girar(idx, () => {
this.idx = idx; var q = this.prizes[idx];
this.confete();
this.status(idx !== this.prizes.indexOf(p) ? 'Subiu! Você ganhou ' + q.label + '!' : 'Manteve: ' + q.label + '!');
this.querySelector('[data-acoes]').hidden = false;
this.querySelector('[data-subir]').hidden = true;
if (idx !== this.prizes.indexOf(p)) { this.cupomServidor = null; this.avisarSubiu(q); }
});
}
// avisa o servidor do prêmio final depois do 2º giro (métrica certa no banco); sem resposta, segue
avisarSubiu(q) {
var url = this.dataset.endpoint; if (!url || this.demo) return;
try { fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, keepalive: true, body: JSON.stringify(Object.assign({ acao: 'subiu' }, this.contato, { premio: q.label, cupom: q.code, tier: q.tier })) }).catch(function () {}); } catch (e) {}
}
girarDemo() {
this.querySelector('[data-girar]').hidden = true; this.status('Girando…');
var idx = pick(this.prizes); this.girar(idx, () => this.parou(idx));
}
mostrarCupom() {
var p = this.prizes[this.idx];
this.resultado = { code: this.cupomServidor || p.code, label: p.label, tier: p.tier, at: Date.now() };
if (!this.demo) LS.set('roleta', this.resultado);
this.show('coupon'); this.renderCupom();
}
renderCupom() {
var r = this.resultado, el = this.querySelector('[data-restante]');
this.querySelector('[data-premio]').textContent = r.label;
this.querySelector('[data-code]').textContent = r.code;
var fn = this.querySelector('[data-frete-note]'); if (fn) fn.hidden = !/frete/i.test(r.label || '');
this.querySelector('[data-usar]').href = '/discount/' + encodeURIComponent(r.code) + '?redirect=' + encodeURIComponent('/collections/all');
if (this.demo) { try { sessionStorage.setItem('roleta_demo_pausa', '1'); } catch (e) {} }
var tick = () => {
var ms = r.at + (+this.dataset.validHours || 24) * 3600000 - Date.now();
if (ms <= 0) { el.textContent = 'tempo esgotado'; return; }
el.textContent = Math.floor(ms / 3600000) + 'h ' + ('0' + Math.floor((ms % 3600000) / 60000)).slice(-2) + 'min';
setTimeout(tick, 30000);
};
tick();
}
copiar() {
var code = this.resultado.code, btn = this.querySelector('[data-copy]');
var ok = () => { btn.textContent = 'Copiado!'; setTimeout(() => { btn.textContent = 'Copiar'; }, 2000); };
(navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(ok).catch(() => {
var s = this.querySelector('[data-code]'), range = document.createRange(); range.selectNodeContents(s);
var sel = getSelection(); sel.removeAllRanges(); sel.addRange(range);
try { document.execCommand('copy'); ok(); } catch (e) {}
});
}
}
customElements.define('roleta-giro', Roleta);
})();
